import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { OTPLoginForm } from '../components/auth/OTPLoginForm';
import { User } from '../types/auth';

export const AuthPage: React.FC = () => {
    const navigate = useNavigate();
    const { isAuthenticated, isLoading, updateUser } = useAuth();

    if (isLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            </div>
        );
    }

    if (isAuthenticated) {
        return <Navigate to="/dashboard" replace />;
    }

    const handleLoginSuccess = (userData: User) => {
        updateUser(userData);
        // Явный редирект после успешной авторизации
        navigate('/dashboard', { replace: true });
    };

    return <OTPLoginForm onSuccess={handleLoginSuccess} />;
};